import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;

export const CardsWrapper = styled.div`
  ${({ theme }) => css`
    display: grid;
    gap: 24px 16px;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      grid-template-columns: repeat(1, 1fr);
      margin-left: -24px;
      margin-right: -24px;
      width: auto;
    }
  `}
`;
export const Card = styled.div`
  position: relative;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  :nth-child(1) {
    grid-row: 1 / -1;
  }

  :hover {
    transform: translateY(-5px);
  }
`;

export const InnerCard = styled.div`
  ${({ theme }) => css`
    @media (min-width: ${theme.v2.breakpoints.md}) {
      border: 1px solid ${theme.v3.colors.neutral[98]};
      border-radius: ${theme.v3.border.radius.round};
      box-shadow: 0 5px 10px 0 rgba(223, 226, 235, 0.24), 0 4px 8px 0 rgba(223, 226, 235, 0.18);
      height: 100%;
      overflow: hidden;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
    
      :hover {
        box-shadow: 0 8px 16px 0 rgba(223, 226, 235, 0.32), 0 6px 12px 0 rgba(223, 226, 235, 0.24);
      }
    }
  `}
`;

export const Image = styled.img`
  cursor: pointer;
  height: 100%;
  object-fit: cover;
  width: 100%;
`;

export const Tag = styled.span`
  ${({ theme }) => css`
    background: ${theme.v3.colors.accent.green[70]};
    border-radius: ${theme.v3.border.radius.sm};
    color: ${theme.v3.colors.neutral[100]};
    font-size: ${theme.v3.font.sizes.small};
    height: 24px;
    line-height: 24px;
    padding: 0 ${theme.v3.spacing.nano};
    position: absolute;
    top: -5px;
    right: 8px;
  `}
`;
